export default function useDefaultTabPath(tabsData) {
  const firstTabPath = tabsData[0] ? tabsData[0].path : '';
  const defaultTab = tabsData.find((item) => item.default);
  const defaultTabPath = defaultTab ? defaultTab.path : firstTabPath;
  return defaultTabPath || '';
}
